var _mask, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleBlockArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 10,
    viewBox: "0 0 20 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_4338_61647",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.0678 0.762695H15.9322L20 4.99998L15.9322 9.23727H4.0678L0 4.99998L4.0678 0.762695Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.0678 0.762695V-0.737305H3.42847L2.98572 -0.276102L4.0678 0.762695ZM15.9322 0.762695L17.0143 -0.276102L16.5715 -0.737305H15.9322V0.762695ZM15.9322 9.23727V10.7373H16.5715L17.0143 10.2761L15.9322 9.23727ZM4.0678 9.23727L2.98572 10.2761L3.42847 10.7373H4.0678V9.23727ZM20 4.99998L21.0821 6.03878L22.0793 4.99998L21.0821 3.96119L20 4.99998ZM0 4.99998L-1.08208 3.96119L-2.07933 4.99998L-1.08208 6.03878L0 4.99998ZM4.0678 2.2627H15.9322V-0.737305H4.0678V2.2627ZM15.9322 7.73727H4.0678V10.7373H15.9322V7.73727ZM14.8501 1.80149L18.9179 6.03878L21.0821 3.96119L17.0143 -0.276102L14.8501 1.80149ZM18.9179 3.96119L14.8501 8.19847L17.0143 10.2761L21.0821 6.03878L18.9179 3.96119ZM5.14988 8.19847L1.08208 3.96119L-1.08208 6.03878L2.98572 10.2761L5.14988 8.19847ZM1.08208 6.03878L5.14988 1.80149L2.98572 -0.276102L-1.08208 3.96119L1.08208 6.03878Z",
    fill: "#2B2B35",
    mask: "url(#path-1-inside-1_4338_61647)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleBlockArrow);
export default __webpack_public_path__ + "static/media/double_block_arrow.3e3063dc9c1339407717b40f44db833c.svg";
export { ForwardRef as ReactComponent };